import { RouteRecordRaw } from 'vue-router';

const rotasModuloEstoques: Array<RouteRecordRaw> = [
  {
    path: '/estoques',
    name: 'ModuloEstoques',
    component: () => import(/* webpackChunkName: "core" */ '@/core/layout/SubLayout.vue'),
    children: [
      {
        path: 'mapa',
        name: 'Mapa',
        meta: {
          titulo: 'Mapa dos Estoques',
          identificadorRecurso: 'MAPA_ESTOQUE',
          identificadorPermissao: 'AUT_MAPA_ESTOQUE',
        },
        component: () => import(/* webpackChunkName: "estoques" */ '@/views/Estoques/MapaEstoque/MapaEstoqueIndex.vue'),
      },
      {
        path: 'balancos',
        name: 'Balancos',
        meta: {
          titulo: 'Balanços de Estoque',
          identificadorRecurso: 'BALANCO_ESTOQUE',
          identificadorPermissao: 'AUT_BALANCO_ESTOQUE',
        },
        component: () => import(/* webpackChunkName: "estoques" */ '@/views/Estoques/BalancoEstoque/BalancoEstoqueIndex.vue'),
      },
      {
        path: 'movimentacoes',
        name: 'MovimentacaoEstoque',
        meta: {
          titulo: 'Movimentação de Estoque',
          identificadorRecurso: 'MOVIMENTACAO_ESTOQUE',
          identificadorPermissao: 'AUT_MOVIMENTACAO_ESTOQUE',
        },
        component: () => import(/* webpackChunkName: "estoques" */ '@/views/Estoques/MovimentacaoEstoque/MovimentacaoEstoqueIndex.vue'),
      },
      {
        path: 'transferencias',
        name: 'TransferenciaEstoque',
        meta: {
          titulo: 'Transferências entre Estoques',
          identificadorRecurso: 'TRANSFERENCIA_ENTRE_ESTOQUES',
          identificadorPermissao: 'AUT_TRANSFERENCIA_ENTRE_ESTOQUES',
        },
        component: () => import(/* webpackChunkName: "estoques" */ '@/views/Estoques/TransferenciaEstoque/TransferenciaEstoqueIndex.vue'),
      },
      {
        path: 'posicao-estoque',
        name: 'PosicaoEstoque',
        meta: {
          titulo: 'Consulta Posição de Estoque',
          identificadorRecurso: 'POSICAO_ESTOQUE',
          identificadorPermissao: 'AUT_POSICAO_ESTOQUE',
        },
        component: () => import(/* webpackChunkName: "estoques" */ '@/views/Estoques/PosicaoEstoque/PosicaoEstoqueIndex.vue'),
      },
      {
        path: 'relatorios/analise-estoque',
        name: 'RelatorioAnaliseEstoque',
        meta: {
          titulo: 'Relatório Análise de Estoque',
          identificadorPermissao: 'REL_ANALISE_ESTOQUE',
          identificadorRecurso: 'RELATORIO_ANALISE_ESTOQUE',
        },
        component: () => import(/* webpackChunkName: "estoques" */ '@/views/Relatorios/Estoque/RelatorioAnaliseEstoqueIndex.vue'),
      },
      {
        path: 'relatorios/inventario-por-lote',
        name: 'RelatorioInventarioPorLote',
        meta: {
          titulo: 'Relatório de Inventário por Lote',
          identificadorPermissao: 'REL_INVENTARIO_POR_LOTE',
          identificadorRecurso: 'RELATORIO_INVENTARIO_POR_LOTE',
        },
        component: () => import(/* webpackChunkName: "estoques" */ '@/views/Relatorios/Estoque/RelatorioInventarioPorLoteIndex.vue'),
      },
      {
        path: 'ajuste-inventario',
        name: 'AjusteInventario',
        meta: {
          titulo: 'Ajuste de Inventário',
          identificadorRecurso: 'AJUSTE_INVENTARIO',
          identificadorPermissao: 'AUT_AJUSTE_INVENTARIO',
        },
        component: () => import(/* webpackChunkName: "estoques" */ '@/views/Estoques/AjusteInventario/AjusteInventarioIndex.vue'),
      },
    ],
  },
  {
    path: '/rastreabilidade-lote',
    name: 'RastreabilidadeLote',
    meta: {
      titulo: 'Rastreabilidade por Lote',
      identificadorRecurso: 'RASTREABILIDADE_LOTE',
      identificadorPermissao: 'AUT_RASTREABILIDADE_LOTE',
    },
    component: () => import(/* webpackChunkName: "estoques" */ '@/views/Estoques/RastreabilidadeLote/RastreabilidadeLoteIndex.vue'),
  },
];

export default rotasModuloEstoques;
